/**
 * Whether an employment record has a portal account, derived rather than stored: both
 * inputs already travel on every employee row, so a server-side copy of this rule would be
 * a second implementation with no consumer. List FILTERING keys off the raw fields
 * (`userId`, `invitedAt`) server-side; this is for display.
 */
export type AccountStatus = 'active' | 'invited' | 'expired' | 'none';

/**
 * Mirrors `invitationExpiresIn` in apps/auth/src/auth.ts — the one constant this design
 * duplicates across services. A mismatch shows a stale "Invited"; it never grants access.
 */
export const INVITATION_WINDOW_DAYS = 7;

type StatusInput = { invitedAt?: string | null; userId?: string | null };

export function accountStatusOf(row: StatusInput, now: Date = new Date()): AccountStatus {
  // A linked userId is the proof of acceptance: the webhook sets it when the invitee's account
  // is provisioned, so it cannot be true before they accepted.
  if (row.userId) {
    return 'active';
  }
  if (!row.invitedAt) {
    return 'none';
  }
  const ageMs = now.getTime() - new Date(row.invitedAt).getTime();
  return ageMs > INVITATION_WINDOW_DAYS * 24 * 60 * 60 * 1000 ? 'expired' : 'invited';
}
